import { graphql, useStaticQuery } from 'gatsby';
import {
  getHero,
  getWhatWeDoGrid,
  getHeroIntroDesign2,
  getBilateralList,
  getEducationPartners,
  getOutreachPartners,
  getPartnerLogoGridLayoutStyle,
} from '../utils/utils';

function homepageData() {
  const raw_data = useStaticQuery(graphql`
    query HomePageQuery {
      allSanityPage(filter: { slug: { current: { eq: "homepage" } } }) {
        edges {
          node {
            _rawBody
          }
        }
      }
      our_list: allSanityPage(filter: { slug: { current: { eq: "education" } } }) {
        edges {
          node {
            body {
              ... on SanityImageTextBlock {
                headline
                links{
                  Link
                }
                blockimage {
                  src {
                    asset {
                      url
                      _createdAt(formatString: "YYYY-MM-DD")
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  const data = raw_data.allSanityPage.edges[0].node._rawBody;
  const our_list = [];
  let counter = 1;
  raw_data.our_list.edges[0].node.body.forEach((element) => {
    if (counter <= 3) {
      if (element.__typename === 'SanityImageTextBlock') {
         console.log(element.blockimage.alt)
        our_list.push({
          imageSrc: element.blockimage.src?.asset.url,
          desc: element.headline,
          linkTo: element.links[0] !== undefined ? element.links[0].Link : "",
        });
        counter += 1;
      }
    } else {
      return false;
    }
  });

  const jsonData = {
    home: {
      hero: getHero(data),
      heroIntro: getHeroIntroDesign2(data),
      bilateralContainer: getBilateralList(data),
      featuredContainer: {
        className: '',
        data: [
          getWhatWeDoGrid(data),
          {
            partnerLogoGrid: {
              partners: [
                {
                  partnerCategory: 'Education',
                  partnerList: getEducationPartners(data),
                },
                {
                  partnerCategory: 'Outreach',
                  partnerList: getOutreachPartners(data),
                },
              ],
              // Here BE must add the Partner logo Grid container and then add the list of partners in it.
              className: getPartnerLogoGridLayoutStyle(data),
            },
            featureHeading: 'our paw-tners',
          },
        ],
      },
    },
  };
  return jsonData;
}

export default homepageData;
